import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "MailAttachement__title" }

import { computed, PropType } from "vue";
import { documentToSlug } from "@/tools/document";
import { Document } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'MailAttachement',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const documentTitle = computed(() => {
    const prefix = props.document.doctype;
    const slug = documentToSlug(props.document);
    return `${prefix}-${slug}.pdf`;
});

const open = () => {
    const fileLocation =
        "https://drive.google.com/file/d/" +
        props.document?.google_drive_id +
        "/view?usp=sharing";
    window.open(fileLocation);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: open,
    class: "MailAttachement"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "MailAttachement__icon" }, [
      _createElementVNode("i", { class: "fas fa-paperclip" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, _toDisplayString(documentTitle.value), 1)
  ]))
}
}

})